"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const archive_1 = __importDefault(require("@powerednow/shared/constants/archive"));
const modelProperties = {
    modelName: 'ArchiveBatchToItem',
    tableName: 'ArchiveBatchToItem',
    associations: [{
            type: 'belongsTo',
            serverOnly: true,
            model: 'ArchiveBatch',
            parameters: {
                as: 'ArchiveBatch',
                foreignKey: {
                    name: 'batch_id',
                    fieldName: 'batch_id',
                },
            },
        }, {
            type: 'hasOne',
            model: 'Note',
            cascadeDelete: false,
            parameters: {
                as: 'Note',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.NOTE,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Document',
            cascadeDelete: false,
            parameters: {
                as: 'Document',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.DOCUMENT,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Action',
            cascadeDelete: false,
            parameters: {
                as: 'Action',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.ACTION,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'FileGroup',
            cascadeDelete: false,
            parameters: {
                as: 'FileGroup',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.FILEGROUP,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'DocumentItem',
            cascadeDelete: false,
            parameters: {
                as: 'DocumentItem',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.DOCUMENTITEM,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'MediaGroup',
            cascadeDelete: false,
            parameters: {
                as: 'MediaGroup',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.MEDIAGROUP,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Media',
            cascadeDelete: false,
            parameters: {
                as: 'Media',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.MEDIA,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Message',
            cascadeDelete: false,
            parameters: {
                as: 'Message',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.MESSAGE,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'JobItemGroup',
            cascadeDelete: false,
            parameters: {
                as: 'JobItemGroup',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.JOBITEMGROUP,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'JobItem',
            cascadeDelete: false,
            parameters: {
                as: 'JobItem',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.JOBITEM,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Payment',
            cascadeDelete: false,
            parameters: {
                as: 'Payment',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.PAYMENT,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'FormDocument',
            cascadeDelete: false,
            parameters: {
                as: 'FormDocument',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.FORMDOCUMENT,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'TimeLog',
            cascadeDelete: false,
            parameters: {
                as: 'TimeLog',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.TIMELOG,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'File',
            cascadeDelete: false,
            parameters: {
                as: 'File',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.FILE,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'PaymentToInvoice',
            cascadeDelete: false,
            parameters: {
                as: 'PaymentToInvoice',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.PAYMENTTOINVOICE,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Checkin',
            cascadeDelete: false,
            parameters: {
                as: 'Checkin',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.CHECKIN,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'Signature',
            cascadeDelete: false,
            parameters: {
                as: 'Signature',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.SIGNATURE,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'UserAction',
            cascadeDelete: false,
            parameters: {
                as: 'UserAction',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.USERACTION,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'DocumentAction',
            cascadeDelete: false,
            parameters: {
                as: 'DocumentAction',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.DOCUMENTACTION,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'MessageAttachments',
            cascadeDelete: false,
            parameters: {
                as: 'MessageAttachments',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.MESSAGEATTACHMENTS,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'CustomerMessageAttachment',
            cascadeDelete: false,
            parameters: {
                as: 'CustomerMessageAttachment',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.CUSTOMERMESSAGEATTACHMENT,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'CustomerMessage',
            cascadeDelete: false,
            parameters: {
                as: 'CustomerMessage',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.CUSTOMERMESSAGE,
            },
            followFor: ['Archive'],
        }, {
            type: 'hasOne',
            model: 'MessageRecipient',
            cascadeDelete: false,
            parameters: {
                as: 'MessageRecipient',
                sourceKey: 'linked_id',
                foreignKey: 'id',
            },
            where: {
                type: archive_1.default.ITEM_TYPES.MESSAGERECIPIENT,
            },
            followFor: ['Archive'],
        },
    ],
    hooks: [],
    validations: {},
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/archiveBatchToItem/modelProperties.js.map